module.exports = __webpack_public_path__ + "static/image1-b2f277fbf70a0e2f6dc7ab2e272b4707.jpg";